module.exports = __webpack_public_path__ + "img/moutarde.7e1bf79c.svg";